import React from 'react';
import PropTypes from 'prop-types';
import ButtonLink from 'components/ui/buttons/ButtonLink';
import Dialog from 'components/ui/Dialog';
import ShowToggle from 'components/ui/ShowToggle';
import CloseProjectForm from './CloseProjectForm';

const ProjectActions = ({
  editPath,
  viewPath,
  showProjectRemoval,
  projectSlug,
}) => (
  <div className="action-buttons col-lg-6 mt-2 mt-md-0 d-flex justify-content-end align-items-center">
    {editPath && (
      <a className="edit-link mr-3" id={`edit-${projectSlug}`} href={editPath}>
        Edit job
        <i className="fa fa-pencil" />
      </a>
    )}
    <a className="view-link mr-3" href={`${viewPath}?from=jobPosts`}>
      View job
      <i className="fa fa-eye" />
    </a>
    {showProjectRemoval ? (
      <ShowToggle>
        {(show, toggle) => (
          <>
            <ButtonLink data-id="close-job-btn" onClick={toggle}>
              Close job
              <i className="fa fa-trash-o" />
            </ButtonLink>
            {show && (
              <Dialog show={show} onHide={toggle} xlarge>
                <CloseProjectForm slug={projectSlug} onCancel={toggle} />
              </Dialog>
            )}
          </>
        )}
      </ShowToggle>
    ) : null}
  </div>
);

ProjectActions.propTypes = {
  editPath: PropTypes.string,
  viewPath: PropTypes.string.isRequired,
  showProjectRemoval: PropTypes.bool,
  projectSlug: PropTypes.string.isRequired,
};

export default ProjectActions;
